import React from 'react';

import { Button, Dialog, Text, VisuallyHidden } from '@betterment/samba-react';

type Props = {
  asOf: string | null;
  performanceDisclosure: string;
};

export const PerformanceDisclosure: React.FC<Props> = ({ asOf, performanceDisclosure }) => {
  return (
    <Text variant="text25" color="text.weak">
      {asOf} See{' '}
      <Dialog overlay="default">
        <Dialog.Trigger data-samba-component={true} asChild={true}>
          <Button variant="textSecondary">disclosure</Button>
        </Dialog.Trigger>
        <VisuallyHidden>
          <Dialog.Title>Performance Disclosure</Dialog.Title>
        </VisuallyHidden>
        <Dialog.Content
          css={{
            padding: 'space.400',
            width: '100%',
            maxWidth: 'container.xlarge',
            maxHeight: '80vh',
            overflow: 'auto',
          }}
          aria-label="Performance disclosure"
        >
          <Dialog.Description asChild={true}>
            <Text dangerouslySetInnerHTML={{ __html: performanceDisclosure }} />
          </Dialog.Description>
          <Dialog.Close asChild={true}>
            <Button variant="solidSecondary" css={{ mt: 'space.300' }}>
              Close
            </Button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog>
      .
    </Text>
  );
};
